import { useMatches } from 'react-router-dom';
import { Rocket } from '../rocket';
import type { RocketMeta } from '../rocket/rocket-configs';
import { getRocketConfigByRoute } from '../rocket/rocket-configs';
import { useEffect, useState } from 'react';

export function RocketMissionControl() {
  const matches = useMatches();
  const [config, setConfig] = useState<RocketMeta | null>(null);
  const [isReady, setIsReady] = useState(false);

  const lastMatch = matches[matches.length - 1];
  const activeRoute = lastMatch?.params['*'];

  useEffect(() => {
    const config = getRocketConfigByRoute(activeRoute);
    setConfig(config);
    if (isReady === false) {
      setIsReady(true);
    }
  }, [activeRoute]);

  // The rocket should only exist on Journeys
  const isJourneys = lastMatch?.id === 'journeys';
  if (!isJourneys) {
    return null;
  }

  // The initial state of the Rocket is dependent on the current route, so we need to wait for
  // at least one render cycle before rendering the Rocket. (`null` is a valid config for pages
  // that do not have a Rocket, which might display a different content).
  if (isReady === false) {
    return null;
  }

  return <Rocket config={config} key={config?.id ?? 'no-config'} onConfigChange={setConfig} />;
}
